import React from "react";

const TermsConditions = () => {
  return (
    <div style={styles.container} className="mt-5">
      <h1 style={styles.title} className="mt-5"><br /></h1>
      <h1 style={styles.title} className="mt-1">Terms & Conditions</h1>
      <p style={styles.effectiveDate}>Effective Date: November 7, 2025</p>
      <p style={styles.effectiveDate}>Last Updated: November 7, 2025</p>

      <p style={styles.paragraph}>
        Welcome to Digital Ledger Media (“we,” “our,” or “us”). By accessing or using our website{" "}
        <a href="https://digitalledgermedia.com" target="_blank" rel="noopener noreferrer" style={styles.link}>
          digitalledgermedia.com
        </a>
        , or any of our services, you agree to comply with and be bound by these Terms & Conditions (“Terms”). Please read them carefully before using our site or engaging with our services.
      </p>
      <p style={styles.paragraph}>If you do not agree to these Terms, please do not use our website or services.</p>
      <hr style={styles.separator} />

      {/* Sections */}
      <Section title="1. Company Overview">
        <p>Digital Ledger Media is a global provider of:</p>
        <ul>
          <li>Digital Marketing & Campaign Strategy</li>
          <li>Financial Intelligence, Research, and Analytics Services</li>
        </ul>
        <p>
          We combine marketing expertise with market intelligence to help brands, investors, and enterprises make informed decisions.
        </p>
      </Section>

      <Section title="2. Acceptance of Terms">
        <p>By accessing our website, engaging our services, or submitting any inquiry, you confirm that:</p>
        <ul>
          <li>You are at least 18 years old.</li>
          <li>You have the authority to enter these Terms on behalf of yourself or your organization.</li>
          <li>You agree to comply with all applicable laws and these Terms.</li>
        </ul>
      </Section>

      <Section title="3. Services">
        <p>We offer:</p>
        <ul>
          <li>Digital campaigns, social media marketing, and branding strategy.</li>
          <li>Market research, financial analytics, and business intelligence reports.</li>
        </ul>
        <p>
          All services are subject to mutual agreement via email, proposal, or written contract. We reserve the right to modify, suspend, or discontinue any service at any time without prior notice.
        </p>
      </Section>

      <Section title="4. Use of Website">
        <p>You agree not to:</p>
        <ul>
          <li>Engage in unauthorized access, data scraping, or reverse engineering.</li>
          <li>Upload viruses, malicious code, or attempt to disrupt website functionality.</li>
          <li>Use our content or data for unlawful, competitive, or misleading purposes.</li>
          <li>Impersonate another entity or misrepresent your affiliation with us.</li>
        </ul>
        <p>We may suspend or terminate your access if you violate these Terms.</p>
      </Section>

      <Section title="5. Intellectual Property">
        <p>
          All content on digitalledgermedia.com, including text, graphics, logos, data, reports, and software, is the intellectual property of Digital Ledger Media unless otherwise stated.
        </p>
        <p>You may not reproduce, distribute, or modify our content without prior written consent.</p>
        <p>Any unauthorized use of our intellectual property may result in legal action.</p>
      </Section>

      <Section title="6. Payments and Billing">
        <p>Where applicable:</p>
        <ul>
          <li>Service fees will be communicated via official quotation, invoice, or contract.</li>
          <li>Payments must be made as per agreed terms.</li>
          <li>Late or incomplete payments may result in suspension or termination of services.</li>
          <li>All fees are non-refundable unless otherwise stated in a specific agreement.</li>
        </ul>
      </Section>

      <Section title="7. Confidentiality">
        <p>
          Both parties agree to maintain confidentiality of any non-public information shared during the course of engagement.
          This includes financial data, campaign strategy, or proprietary business information.
        </p>
        <p>Confidentiality obligations remain in effect even after the termination of services.</p>
      </Section>

      <Section title="8. Disclaimer of Warranties">
        <p>All services and website content are provided on an “as is” and “as available” basis.</p>
        <p>We make no warranties, express or implied, regarding:</p>
        <ul>
          <li>Accuracy or completeness of financial data or marketing analytics.</li>
          <li>Future performance of investment insights or campaign outcomes.</li>
        </ul>
        <p>
          You understand that financial and market intelligence involves inherent uncertainties, and Digital Ledger Media shall not be held liable for any losses arising from reliance on our reports or insights.
        </p>
      </Section>

      <Section title="9. Limitation of Liability">
        <p>To the fullest extent permitted by law:</p>
        <ul>
          <li>Digital Ledger Media shall not be liable for any indirect, incidental, or consequential damages.</li>
          <li>Our total liability for any claim shall not exceed the amount paid by the client for the service in question.</li>
        </ul>
      </Section>

      <Section title="10. Third-Party Links">
        <p>
          Our website may contain links to third-party websites or services. We are not responsible for their content, accuracy, or privacy practices. Use of third-party resources is at your own risk.
        </p>
      </Section>

      <Section title="11. Data Protection & Privacy">
        <p>
          Your personal data is handled in accordance with our Privacy Policy, which complies with the DPDP Act (India), GDPR (EU), and CCPA (US) standards.
        </p>
      </Section>

      <Section title="12. Termination">
        <p>
          We reserve the right to terminate or suspend your access to our website or services at any time, with or without cause, and without liability.
        </p>
      </Section>

      <Section title="13. Governing Law">
        <p>
          These Terms shall be governed by and construed in accordance with the laws of India, without regard to conflict of law principles. For international clients, disputes may be handled under mutually agreed jurisdiction or arbitration.
        </p>
      </Section>

      <Section title="14. Changes to Terms">
        <p>
          We may modify or update these Terms from time to time. The latest version will always be available on our website with the updated “Last Updated” date.
          Your continued use of our website or services after changes signifies acceptance of the revised Terms.
        </p>
      </Section>

      <Section title="15. Contact Us">
        <p>For any questions regarding these Terms, please contact:</p>
        <p>Digital Ledger Media</p>
        <p>📧 Email: <a href="mailto:Collab@digitalledgermedia.com" style={styles.link}>Collab@digitalledgermedia.com</a></p>
        <p>🌐 Website: <a href="https://digitalledgermedia.com" target="_blank" rel="noopener noreferrer" style={styles.link}>digitalledgermedia.com</a></p>
        <p>📍 Address: Delhi, India</p>
      </Section>
    </div>
  );
};

const Section = ({ title, children }) => {
  return (
    <section style={{ marginBottom: "2rem" }}>
      <h2 style={styles.sectionTitle}>{title}</h2>
      <div>{children}</div>
    </section>
  );
};

const styles = {
  container: {
    maxWidth: "900px",
    margin: "2rem auto",
    color: "#222",
    fontFamily: "'Inter', sans-serif",
    lineHeight: 1.6,
    padding: "0 1rem",
  },
  title: {
    color: "#ff6a00",
    fontWeight: "700",
    fontSize: "2.5rem",
    marginBottom: "1rem",
  },
  effectiveDate: {
    color: "#555",
    fontWeight: "600",
    marginBottom: "1rem",
  },
  paragraph: {
    marginBottom: "1rem",
    fontSize: "1rem",
  },
  link: {
    color: "#ff007f",
    textDecoration: "none",
  },
  sectionTitle: {
    color: "#ff6a00",
    fontWeight: "600",
    fontSize: "1.5rem",
    marginBottom: "0.5rem",
  },
  separator: {
    borderTop: "1px solid #ff6a00",
    margin: "1rem 0",
  },
};

export default TermsConditions;
